import { Component } from 'react';

// Without this, any uncaught render-time exception unmounts the whole React
// tree and leaves a totally blank page with no way to recover except a hard
// refresh. This turns that into a visible, recoverable message instead.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] caught render error:', error, info?.componentStack);
    // Minified production stack traces are frequently unreadable in the
    // browser console (and sourcemap resolution isn't reliable across every
    // browser/extension setup) -- send the real error to the server so it
    // shows up in `docker compose logs` instead of staying stuck as "n is
    // not a function" forever.
    fetch('/api/client-error', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: error?.message,
        stack: error?.stack,
        componentStack: info?.componentStack,
        url: window.location.href,
      }),
    }).catch(() => {});
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-mist p-6 text-center dark:bg-charcoal">
          <p className="text-sm text-steel">Something went wrong loading this page.</p>
          <button className="btn-primary" onClick={() => window.location.assign('/')}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
